import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=4c2b82a3&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=4c2b82a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b82a3",
  null
  
)

export default component.exports